import { useContext, useEffect, useState } from "react"
import UiButton1 from "../../components/ui_button1"
import { AppContext } from "../../context/context"
import { apiUrl } from "../../config/delcare"
import UiSpinner from "../../components/ui_spinner"

const UserDelete = () => {

    const {
        selectedUser,
        setSelectedUser,
        setReloadList,
        setToastContent,
        toastInit,
        token,
        offCanvas,
        neonUser,
        fetchData,
        fetchDataV2
    } = useContext(AppContext)

    const [load, setLoad] = useState(false)
    const [error, setError] = useState("")

    const deleteUserHandler = async () => {
        setError("")
        setLoad(true)
        // console.log({ selectedUser })
        // return
        try {
            let del = await fetch(`${apiUrl}/delete_user`, {
                method: "POST",
                headers: (() => {
                    let myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("Authorization", "Bearer " + token.accessToken);

                    return myHeaders

                })(),
                body: JSON.stringify({ user_id: selectedUser.user_id })
            })

            if (!del.ok) {
                console.log({ error: "Something went wrong." })
                setError("Something went wrong.")
                setLoad(false)

                return
            }

            // await fetchData(`
            //     INSERT INTO deleted_data (deleted_by_user_id, data_json) 
            //     VALUES 
            //     ('${neonUser.user_id}', '${JSON.stringify(selectedUser)}')`, "/neon-query")
            let query1 = "INSERT_DELETED_DATA", params1 = [neonUser.user_id, JSON.stringify(selectedUser)]

            await fetchDataV2(query1, params1, "/neon-query-v2")

            offCanvas.hide()
            setSelectedUser(null)
            setLoad(false)
            setToastContent("User is deleted.")
            toastInit.show()
            setReloadList(true)
        }
        catch (err) {
            console.log({ error: "something went wrong: " + err })
            setError("Something went wrong: " + err)
            setLoad(false)
        }
        return


    }

    useEffect(() => {
        console.log({ selectedUser })
    }, [selectedUser])
    return (
        <div className="h-100 d-flex flex-column justify-content-between">
            <div>
                {error && <p className="poppins text-danger mb-1">{error}</p>}
                <p className="poppins">Please confirm that you would like to permanently delete this user.  This cannot be undone.</p>
            </div>


            {load ?
                <UiSpinner />
                :
                <UiButton1 text="Delete" submit={deleteUserHandler} />

            }

        </div>

    )
}


export default UserDelete